import { render, staticRenderFns } from "./MedalProfile.vue?vue&type=template&id=472148cf&"
import script from "./MedalProfile.vue?vue&type=script&lang=js&"
export * from "./MedalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports